import React from 'react';
// Config file to manage App Configuration Variables

// Max Recipient Count per Transfer
// NOTE: This value is also contained in the Teller Application
export const MAX_RECIPIENT_COUNT = 20;

// Batch Transfer Configuration
export const BATCH_SIZE = 1000; // Recipients per batch
export const BATCH_DELAY_MS = 0; // 5 seconds between batch starts

export const VALUE_LOAD_FILE_UPLOAD_LENGTH_LIMIT = 10000;
export const SYSTEMSERVICES = [
  'CardIssuing',
  'Visa Direct',
  'Collections',
  'e-Transfer',
  'Instant Issuance',
  'KYC',
  'Notifications',
  'Dashboard - Cardholder Portal',
  'Dashboard - Client Portal',
];
export const STATUSCATEGORIES = [
  {
    id: 'operational',
    name: 'Operational',
    description: 'All systems are operating normally without any known issues.',
    icon: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.5278 2.77756C9.15391 2.39641 10.8461 2.39641 12.4722 2.77756C13.6284 3.0472 14.6859 3.63499 15.5254 4.47442C16.3648 5.31386 16.9526 6.37145 17.2222 7.52756C17.6034 9.15367 17.6034 10.8459 17.2222 12.472C16.9526 13.6281 16.3648 14.6857 15.5254 15.5251C14.6859 16.3646 13.6284 16.9524 12.4722 17.222C10.8461 17.6031 9.15391 17.6031 7.5278 17.222C6.37169 16.9524 5.3141 16.3646 4.47467 15.5251C3.63523 14.6857 3.04745 13.6281 2.7778 12.472C2.39666 10.8459 2.39666 9.15367 2.7778 7.52756C3.04745 6.37145 3.63523 5.31386 4.47467 4.47442C5.3141 3.63499 6.37169 3.0472 7.5278 2.77756ZM12.5556 8.722C12.644 8.62991 12.6922 8.50648 12.6896 8.37885C12.687 8.25122 12.6338 8.12985 12.5417 8.04145C12.4496 7.95304 12.3262 7.90484 12.1985 7.90744C12.0709 7.91005 11.9495 7.96325 11.8611 8.05534L9.41669 10.6942L8.16669 9.44422C8.07667 9.36422 7.95948 9.32164 7.8391 9.32518C7.71872 9.32873 7.60425 9.37813 7.51909 9.46329C7.43393 9.54845 7.38452 9.66292 7.38098 9.7833C7.37744 9.90369 7.42002 10.0209 7.50002 10.1109L9.08336 11.6942C9.12758 11.7422 9.18127 11.7805 9.24103 11.8067C9.30079 11.8329 9.36533 11.8464 9.43058 11.8464C9.49583 11.8464 9.56037 11.8329 9.62013 11.8067C9.67989 11.7805 9.73358 11.7422 9.7778 11.6942L12.5556 8.722Z"
          fill="#19814E"
        />
      </svg>
    ),
  },
  {
    id: 'degraded_performance',
    name: 'Degraded Performance',
    description:
      'Some systems are experiencing slower response times or reduced performance, but core functionality remains available.',
    icon: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_585_3305)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.5 4.16667C2.5 3.72464 2.67559 3.30072 2.98816 2.98816C3.30072 2.67559 3.72464 2.5 4.16667 2.5H15.8333C16.2754 2.5 16.6993 2.67559 17.0118 2.98816C17.3244 3.30072 17.5 3.72464 17.5 4.16667V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V4.16667ZM11.6 6.36667C11.3 5.63333 10.2667 5.66667 10 6.43333L8.53333 11.1L8.2 10.4667C8.12423 10.3427 8.02235 10.2367 7.90146 10.1561C7.78057 10.0755 7.64357 10.0223 7.5 10H5.83333C5.61232 10 5.40036 10.0878 5.24408 10.2441C5.0878 10.4004 5 10.6123 5 10.8333C5 11.0543 5.0878 11.2663 5.24408 11.4226C5.40036 11.5789 5.61232 11.6667 5.83333 11.6667H7L8 13.7C8.33333 14.3667 9.33333 14.3 9.56667 13.5667L10.9333 9.16667L11.7333 11.1667C11.8889 11.5222 12.1444 11.7 12.5 11.7H14.1667C14.2761 11.7 14.3845 11.6784 14.4856 11.6366C14.5867 11.5947 14.6785 11.5333 14.7559 11.4559C14.8333 11.3785 14.8947 11.2867 14.9366 11.1856C14.9784 11.0845 15 10.9761 15 10.8667C15 10.7572 14.9784 10.6489 14.9366 10.5478C14.8947 10.4467 14.8333 10.3548 14.7559 10.2774C14.6785 10.2 14.5867 10.1386 14.4856 10.0968C14.3845 10.0549 14.2761 10.0333 14.1667 10.0333H13.0667L11.6 6.36667Z"
            fill="#F5A800"
          />
        </g>
        <defs>
          <clipPath id="clip0_585_3305">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
  },
  {
    id: 'partial_outage',
    name: 'Partial Outage',
    description:
      'A subset of services or features is currently unavailable or impaired, affecting some users.',
    icon: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.6333 12.8331L12.7 4.63311C12.0667 3.53311 11.0667 2.93311 9.99999 2.93311C8.93332 2.93311 7.93332 3.53311 7.29998 4.63311L2.36665 12.8331C1.69999 13.9331 1.63332 15.0998 2.16665 16.0331C2.74443 16.9887 3.68887 17.4775 4.99999 17.4998H15C16.2667 17.4998 17.3 16.9664 17.8333 16.0331C18.3667 15.0998 18.3 13.9331 17.6333 12.8331ZM9.99999 14.6331C9.6552 14.6331 9.32454 14.4961 9.08075 14.2523C8.83695 14.0085 8.69999 13.6779 8.69999 13.3331C8.69999 12.9883 8.83695 12.6577 9.08075 12.4139C9.32454 12.1701 9.6552 12.0331 9.99999 12.0331C10.3448 12.0331 10.6754 12.1701 10.9192 12.4139C11.163 12.6577 11.3 12.9883 11.3 13.3331C11.3 13.6779 11.163 14.0085 10.9192 14.2523C10.6754 14.4961 10.3448 14.6331 9.99999 14.6331ZM11.3667 8.4331L10.2 11.3331C10.1555 11.422 10.0889 11.4664 9.99999 11.4664C9.88887 11.4664 9.82221 11.422 9.79998 11.3331L8.63332 8.46644L8.53332 7.93311C8.53332 7.13311 9.19999 6.46644 9.99999 6.46644C10.2346 6.46838 10.4653 6.52657 10.6728 6.63613C10.8802 6.7457 11.0584 6.90343 11.1923 7.09609C11.3262 7.28876 11.4119 7.51073 11.4422 7.74337C11.4726 7.97602 11.4466 8.21255 11.3667 8.4331Z"
          fill="#E07000"
        />
      </svg>
    ),
  },
  {
    id: 'major_outage',
    name: 'Major Outage',
    description:
      'A significant portion of systems is unavailable, resulting in a major service disruption.',
    icon: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.6 2.7L2.7 6.6C2.57439 6.72309 2.5025 6.89082 2.5 7.06667V12.9333C2.5 13.1556 2.56667 13.3111 2.7 13.4L6.6 17.3C6.72309 17.4256 6.89082 17.4975 7.06667 17.5H12.9333C13.1556 17.5 13.3111 17.4333 13.4 17.3L17.3 13.4C17.4256 13.2769 17.4975 13.1092 17.5 12.9333V7.06667C17.5 6.84444 17.4333 6.68889 17.3 6.6L13.4333 2.7C13.3102 2.57439 13.1425 2.5025 12.9667 2.5H7.06667C6.84444 2.5 6.68889 2.56667 6.6 2.7ZM10 5.83333C10.221 5.83333 10.433 5.92113 10.5893 6.07741C10.7455 6.23369 10.8333 6.44565 10.8333 6.66667V10.8333C10.8333 11.0543 10.7455 11.2663 10.5893 11.4226C10.433 11.5789 10.221 11.6667 10 11.6667C9.77899 11.6667 9.56702 11.5789 9.41074 11.4226C9.25446 11.2663 9.16667 11.0543 9.16667 10.8333V6.66667C9.16667 6.44565 9.25446 6.23369 9.41074 6.07741C9.56702 5.92113 9.77899 5.83333 10 5.83333ZM9.16667 13.3333C9.16667 13.1123 9.25446 12.9004 9.41074 12.7441C9.56702 12.5878 9.77899 12.5 10 12.5C10.221 12.5 10.433 12.5878 10.5893 12.7441C10.7455 12.9004 10.8333 13.1123 10.8333 13.3333C10.8333 13.5543 10.7455 13.7663 10.5893 13.9226C10.433 14.0789 10.221 14.1667 10 14.1667C9.77899 14.1667 9.56702 14.0789 9.41074 13.9226C9.25446 13.7663 9.16667 13.5543 9.16667 13.3333Z"
          fill="#CC0000"
        />
      </svg>
    ),
  },
  {
    id: 'maintenance',
    name: 'Maintenance',
    description:
      'Scheduled or emergency maintenance is in progress, which may impact service availability temporarily.',
    icon: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 2C4.93913 2 3.92172 2.42143 3.17157 3.17157C2.42143 3.92172 2 4.93913 2 6L2 14C2 15.0609 2.42143 16.0783 3.17157 16.8284C3.92172 17.5786 4.93913 18 6 18H14C15.0609 18 16.0783 17.5786 16.8284 16.8284C17.5786 16.0783 18 15.0609 18 14V6C18 4.93913 17.5786 3.92172 16.8284 3.17157C16.0783 2.42143 15.0609 2 14 2H6ZM13.28 5.28C12.7202 5.01264 12.0913 4.9254 11.4798 5.03031C10.8684 5.13522 10.3045 5.42711 9.86579 5.86579C9.42711 6.30446 9.13522 6.86835 9.03031 7.4798C8.9254 8.09125 9.01264 8.72019 9.28 9.28L5.28 13.28C5.16538 13.366 5.07057 13.4756 5.002 13.6013C4.93342 13.7271 4.89267 13.8662 4.88252 14.0091C4.87236 14.152 4.89303 14.2954 4.94313 14.4297C4.99323 14.5639 5.07158 14.6858 5.17289 14.7871C5.2742 14.8884 5.3961 14.9668 5.53032 15.0169C5.66455 15.067 5.80798 15.0876 5.95089 15.0775C6.0938 15.0673 6.23286 15.0266 6.35865 14.958C6.48445 14.8894 6.59404 14.7946 6.68 14.68L10.68 10.68C11.2398 10.9474 11.8687 11.0346 12.4802 10.9297C13.0916 10.8248 13.6555 10.5329 14.0942 10.0942C14.5329 9.65554 14.8248 9.09165 14.9297 8.4802C15.0346 7.86875 14.9474 7.23981 14.68 6.68L12.68 8.68C12.594 8.79462 12.4844 8.88943 12.3587 8.958C12.2329 9.02658 12.0938 9.06733 11.9509 9.07748C11.808 9.08764 11.6646 9.06697 11.5303 9.01687C11.3961 8.96677 11.2742 8.88842 11.1729 8.78711C11.0716 8.6858 10.9932 8.5639 10.9431 8.42968C10.893 8.29545 10.8724 8.15202 10.8825 8.00911C10.8927 7.8662 10.9334 7.72714 11.002 7.60135C11.0706 7.47555 11.1654 7.36596 11.28 7.28L13.28 5.28Z"
          fill="#482764"
        />
      </svg>
    ),
  },
];
export const STATUSSEVERITIES = [
  {
    id: 1,
    label: 'Critical',
    description:
      'Severe outage or data loss affecting core systems. Requires immediate attention.',
    color: '#D32F2F',
    icon: (
      <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
        <path
          fill="#D32F2F"
          d="M12 2L2 22h20L12 2zm0 13v-4h0v4h0zm0 4h0v0h0v0z"
        />
      </svg>
    ),
  },
  {
    id: 2,
    label: 'High',
    description:
      'Major functionality impaired but some operations may continue.',
    color: '#F57C00',
    icon: (
      <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
        <path
          fill="#F57C00"
          d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
        />
      </svg>
    ),
  },
  {
    id: 3,
    label: 'Medium',
    description: 'Moderate issue with limited impact or workaround available.',
    color: '#FBC02D',
    icon: (
      <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
        <path
          fill="#FBC02D"
          d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm0 15h-1v-6h2v6h-1zm0-8h-1V7h2v2h-1z"
        />
      </svg>
    ),
  },
  {
    id: 4,
    label: 'Low',
    description: 'Minor issue, no significant impact on functionality.',
    color: '#7ccbd1',
    icon: (
      <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
        <path
          fill="#7ccbd1"
          d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm-1 15l-5-5 1.4-1.4L11 14.2l5.6-5.6L18 10l-7 7z"
        />
      </svg>
    ),
  },
  {
    id: 5,
    label: 'Notice',
    description: 'Informational message or scheduled maintenance. No outage.',
    color: '#607D8B',
    icon: (
      <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
        <path
          fill="#607D8B"
          d="M12 22a2 2 0 0 0 2-2h-4a2 2 0 0 0 2 2zm6-6v-5a6 6 0 0 0-5-5.9V4a1 1 0 1 0-2 0v1.1A6 6 0 0 0 6 11v5l-2 2v1h16v-1l-2-2z"
        />
      </svg>
    ),
  },
];
